//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import AgendamentoTarefa from '../../../../spa/administracao/AgendamentoTarefa';
import RateioAcordo from '../../../../spa/administracao/RateioAcordo';
import CacheManager from '../../../../spa/administracao/CacheManager';

export default {
  name: 'Administracao',
  data() {
    return {
      tabSelecionada: null,
    };
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'ADMINISTRACAO_PAGINA').length;
    },
  },
  components: {
    AgendamentoTarefa,
    RateioAcordo,
    CacheManager,
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/administracao/Administracao.vue?vue&type=script&lang=js&